import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { parseDateString } from '@co-3/ctrl-ui/common';
import { CtrlIconsModule } from '@co-3/ctrl-ui/icons';
import { isBefore, isSameDay } from 'date-fns';
import { SharedModule } from '../../../shared/shared.module';
import { ContractWidget } from '@models/contract-widgets';
import { Contract } from '@models/contract';
import { DamageReportButtonComponent, PortalWidgetDetailsComponent } from '../../components';
import { InsuranceTypePipe } from 'app/shared/pipes/insurance-type.pipe';

@Component({
    selector: 'app-contract-data-base',
    imports: [
        CtrlIconsModule,
        SharedModule,
        DamageReportButtonComponent,
        PortalWidgetDetailsComponent,
        InsuranceTypePipe,
    ],
    templateUrl: './contract-general-information-widget.component.html',
    styleUrl: './contract-general-information-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractGeneralInformationWidgetComponent implements ContractWidget {
    public contract = input.required<Contract>();

    protected hasContractStarted = computed(() => {
        const contractFrom = parseDateString(this.contract().contractFrom, 'dd.MM.yyyy');
        const now = new Date();
        return isBefore(contractFrom, now) || isSameDay(contractFrom, now);
    });
}
